import axios from "axios";
import { refreshToken } from "../helpers/RequestExecutor";

export const getStockPrices = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/stocks/prices`, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        });
        return response.data;
    } catch (e) {
        if (e.status === 401) {
            await refreshToken();
            return await getStockPrices();
        } else {
            return e.response.data;
        }
    }
}

export const loan = async () => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/stocks/loan`, {}, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        });
        return response.data
    } catch (e) {
        if (e.status === 401) {
            await refreshToken();
            return await loan();
        } else {
            return e.response.data;
        }
    }
}

export const pass = async () => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/stocks/pass`, {}, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        });
        return response.data
    }
    catch (e) {
        if (e.status === 401) {
            await refreshToken();
            return await pass();
        } else {
            return e.response.data;
        }
    }
}

export const getStockHistory = async (company) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/stocks/history?company=${company}`, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        });
        return response.data
    }
    catch (e) {
        if (e.status === 401) {
            await refreshToken();
            return await getStockHistory(company);
        } else {
            return e.response.data;
        }
    }
}

export const getAvailableShares = async (company) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/stocks/available?company=${company}`, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        });
        return response.data
    }
    catch (e) {
        if (e.status === 401) {
            await refreshToken();
            return await getAvailableShares(company);
        } else {
            return e.response.data;
        }
    }
}

export const purchase = async (stock, units, rightIssue) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/stocks/purchase`, { stock, units, rightIssue }, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        });
        return response.data
    }
    catch (e) {
        if (e.status === 401) {
            await refreshToken();
            return await purchase(stock, units, rightIssue);
        } else {
            return e.response.data;
        }
    }
}

export const sell = async (stock, units, debenture) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/stocks/sell`, { stock, units, debenture }, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        });
        return response.data
    }
    catch (e) {
        if (e.status === 401) {
            await refreshToken();
            return await sell(stock, units, debenture);
        } else {
            return e.response.data;
        }
    }
}

export const getTransactionHistory = async (company) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/stocks/transaction-history?company=${company}`, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        });
        return response.data
    }
    catch (e) {
        if (e.status === 401) {
            await refreshToken();
            return await getTransactionHistory(company);
        } else {
            return e.response.data;
        }
    }
}

export const computeCallPremium = async (company, units, validity, strikePrice) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/stocks/call-option-premium?company=${company}&units=${units}&validity=${validity}&strikePrice=${strikePrice}`, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        });
        return response.data
    }
    catch (e) {
        if (e.status === 401) {
            await refreshToken();
            return await computeCallPremium(company, units, validity, strikePrice);
        } else {
            return e.response.data;
        }
    }
}

export const computePutPremium = async (company, units, validity, strikePrice) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/stocks/put-option-premium?company=${company}&units=${units}&validity=${validity}&strikePrice=${strikePrice}`, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        });
        return response.data
    }
    catch (e) {
        if (e.status === 401) {
            await refreshToken();
            return await computePutPremium(company, units, validity, strikePrice);
        } else {
            return e.response.data;
        }
    }
}

export const callOption = async (company, units, validity, strikePrice) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/stocks/create-call-option`, {
            company,
            strikePrice: Number(strikePrice),
            validity: Number(validity),
            units: Number(units)
        }, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        });
        return response.data
    }
    catch (e) {
        if (e.status === 401) {
            await refreshToken();
            return await callOption(company, units, validity, strikePrice);
        } else {
            return e.response.data;
        }
    }
}

export const putOption = async (company, units, validity, strikePrice) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/stocks/create-put-option`, {
            company,
            strikePrice: Number(strikePrice),
            validity: Number(validity),
            units: Number(units)
        }, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        });
        return response.data
    }
    catch (e) {
        if (e.status === 401) {
            await refreshToken();
            return await putOption(company, units, validity, strikePrice);
        } else {
            return e.response.data;
        }
    }
}

export const executeOption = async (optionId) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/stocks/options/${optionId}/execute`, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        });
        return response.data
    }
    catch (e) {
        if (e.status === 401) {
            await refreshToken();
            return await executeOption();
        } else {
            return e.response.data;
        }
    }
}